
import './Signin.css';
import { useState } from 'react';
import Register from '../Register/Register';
import { useSocket } from '../../context/socketContext';

function Signin({ onPageRouteChange }) {
  const [signinUsername, setSigninUsername] = useState('');
  const [signinPassword, setSigninPassword] = useState('');
  const [signinState, setsigninState] = useState(false);

  const [SigninRoute, setSigninRoute] = useState("Signin");
  const { globalUserName, setGlobalUserName } = useSocket();

  const onSigninChange = (desiredChoice) => {
    if (desiredChoice === 'Home') {
      document.getElementById('formDisplayer').style.visibility = 'hidden';
      document.getElementById('Signinback').style.visibility = 'hidden';
      document.getElementById("Home").style.overflowY = "visible";
      document.getElementById("Home").style.height = "auto";
      document.getElementById("Home").style.position = "relative";
    } else {

      setSigninRoute(desiredChoice);
    }

  }
  function clickOnChangeSignin() {
    fetch('https://nestjs-socket-server-production.up.railway.app/users/signin', {
      method: 'POST', // or 'PUT'
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        username: signinUsername,
        password: signinPassword
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        setsigninState(data);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    if (signinState) {
      onPageRouteChange();
      setGlobalUserName(signinUsername);

    }

  }
  const setUserName1 = (event) => {
    // show the user input value to console
    setSigninUsername(event.target.value);
  };
  const setPassWord1 = (event) => {
    // show the user input value to console
    setSigninPassword(event.target.value);

  };
  return (
    <div id='formDisplayer'>

      {SigninRoute === 'Signin' ?
        <div className="SigninPart">

          <div className='SigninForm'>
            <h1 onClick={() => onSigninChange('Home')} className='quit'>X</h1>
            <div>
              <h1 >WELCOME</h1>
              <div>
                <input onChange={setUserName1}></input>
              </div>

              <div>
                <input onChange={setPassWord1}></input>
              </div>
              {/* onClick={onSigninChange('Home')} */}
              <div className='Option'>
                <button onClick={clickOnChangeSignin}>Sign in</button>
                <h3>or</h3>
                <button onClick={() => onSigninChange('Register')}>Register</button>

              </div>
            </div>
          </div>
        </div> :
        <div className='RegisterWrapper'>
          <Register onPageRouteChange={onPageRouteChange} />
        </div>
      }
    </div>
  );
}

export default Signin;
